import { useState, useEffect, useContext, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Container, Stack, Button, IconButton, Backdrop, CircularProgress } from '@mui/material';
import { DataGrid, jaJP } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import axios from "axios";
import dayjs from 'dayjs';

import { API } from "./constantsFront";
import { PAGE_SIZE, MSG } from "./constantsFront";
import { error } from "jquery";
import { MsgContext } from "../../App";


/**
 * よくあるご質問
 * @returns
 */

const G0224QuestionList = () => {
	const [pageSize, setPageSize] = useState(PAGE_SIZE); 	//ページサイズ
	const { msg, setMsg } = useContext(MsgContext);				// エラーメッセージ
	const [isLoading, setIsLoading] = useState(false);  	// Loading

	const [rows, setRows] = useState([]); //質問表示用

	let body = { authKey: API.API_KEY };

	// useEffect初回読込フラグ
	const refIsFirst = useRef(true);
	useEffect(() => {
		//初回読込チェック
		if (!refIsFirst.current) {
			return;
		}

		displayData();

		//初回読込フラグをfalseにセット
		refIsFirst.current = false;
	})

	//表示データ用
	function displayData() {
		// Loading
		setIsLoading(true);
		//質問一覧取得
		axios.post("/m_question/select/add_cate_name/auth", body).then(res => {
			if (res.status !== 200) {												//データ取得エラー
				setMsg("データを正常に取得できませんでした。");
				return;
			} else {																				//正常時
				let Qlist = res.data.questionList;
				let rowData = [];
				for (let i in Qlist) {
					rowData.push({
						id: Qlist[i].question_id
						, category_name: Qlist[i].category_name
						, contents_question: Qlist[i].contents_question
						, display_order: Qlist[i].display_order
						, publish_date: Qlist[i].publish_date ? dayjs(Qlist[i].publish_date).format('YYYY-MM-DD HH:mm:ss') : null
					})
				}
				setRows(rowData);
			}
		}).catch(error => {
			console.log("error : ", error.message);
			setMsg(MSG.EXCEPTION);
		}).finally(() => {
			// Loading
			setIsLoading(false);
		})
	}

	//グリッドヘッダー
	const columns = [
		{ field: 'id', headerName: '質問ID', width: 100 },
		{ field: 'category_name', headerName: 'カテゴリー名', flex: 1 },
		{ field: 'contents_question', headerName: '質問内容', width: 200 },
		{ field: 'display_order', headerName: '表示順', width: 100 },
		{ field: 'publish_date', headerName: '公開日時', width: 150 },
		{
			field: 'edit', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
			renderCell: (params) => <Link to={"/G0225QuestionEdit"} state={{ ID: params.id }}>
				<Tooltip title="編集" arrow>
					<IconButton>
						<EditIcon />
					</IconButton>
				</Tooltip></Link>
		},
		{
			field: 'delete', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
			renderCell: (params) =>
				<Tooltip title="削除" arrow>
					<IconButton onClick={() => deleteQuestion(params.id)}>
						<DeleteIcon />
					</IconButton>
				</Tooltip>
		},
	];

	//削除ボタン処理
	async function deleteQuestion(select_id) {
		try {
			if (window.confirm("削除してもよろしいですか？")) {
				console.log("削除処理開始");

				let csletr = [];
				let arrStr = [];
				csletr.push(select_id);
				arrStr = JSON.stringify(csletr);
				body.arrStr = arrStr;

				let res = await axios.post("/m_question/delete/auth", body);
				if (res.status !== 200) {
					console.log("削除終了(失敗)");
					return;
				} else {
					console.log("削除終了(成功)");
					return window.location.reload();
				}
			} else {
				console.log("キャンセル");
			}
		} catch (error) {
			console.log("削除処理(例外発生)");
			console.log("error : " + error.message);
			setMsg(MSG.EXCEPTION);
		}
	}

	return (
		<>
			<div class="mainLinkMenu"></div>
			<div id="homeContents">
				<div class="homeContentsInner">
					<div class="mainCont">
						<div class="selectSearchArea">
							<Container maxWidth="lg">

								<Backdrop open={isLoading}
									sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
									<CircularProgress />
								</Backdrop>

								<Stack spacing={2}>

									<h1>質問内容</h1>

									<Stack spacing={2} direction="row">
										<Button component={Link} to={"/G0221Question"}
											style={{ width: "200px", color: "white", textDecoration: "none" }}>
											戻る
										</Button>

										<Button component={Link} to={"/G0225QuestionEdit"}
											state={{ ID: -1 }}
											style={{ width: "200px", color: "white", textDecoration: "none" }}>
											新規追加
										</Button>
									</Stack>

									<div style={{ widthh: '100%	' }}>
										<DataGrid
											className="DataGrid"
											columns={columns}
											rows={rows}
											autoHeight
											disableSelectionOnClick
											pageSize={pageSize}
											onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
											pagination
											localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
										/>
									</div>

								</Stack>
							</Container>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default G0224QuestionList;